import * as React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { cn } from '@/lib/utils'

interface LoadingModalProps {
  open: boolean
  message?: string
}

const LoadingModalOverlay = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      'fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
      className
    )}
    {...props}
  />
))
LoadingModalOverlay.displayName = 'LoadingModalOverlay'

export function LoadingModal({
  open,
  message = 'Loading...',
}: LoadingModalProps) {
  return (
    <DialogPrimitive.Root open={open}>
      <DialogPrimitive.Portal>
        <LoadingModalOverlay />
        <DialogPrimitive.Content
          className='fixed left-[50%] top-[30%] z-50 min-w-[424px] translate-x-[-50%] translate-y-[-50%] bg-white rounded-lg shadow-xl p-12 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0'
          onPointerDownOutside={e => e.preventDefault()}
          onInteractOutside={e => e.preventDefault()}
        >
          <DialogPrimitive.Title className='sr-only'>
            {message}
          </DialogPrimitive.Title>
          <div className='flex flex-col items-center justify-center space-y-6'>
            {/* Spinner */}
            <div className='relative w-16 h-16'>
              <div className='absolute inset-0 rounded-full border-4 border-gray-200'></div>
              <div className='absolute inset-0 rounded-full border-4 border-transparent border-t-[#DC143C] animate-spin'></div>
            </div>

            {/* Loading Text */}
            <p className='text-base text-gray-700 font-medium'>{message}</p>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
